module.exports = {
      id: "settings-usage",
      viewBox: "0 0 26.292 27",
      url: "img/" + "sprite.svg#settings-usage",
      toString: function () {
        return this.url;
      }
    }